import { configureStore } from "@reduxjs/toolkit";
import langReducer from "./slices/langSlice";
import showMenuReducer from "./slices/showMenuSlice";
import loginReducer from "./slices/loginSlice";
import contentReducer from "./slices/contentSlice";
import menuGroupReducer from "./slices/menuGroupSlice";
import contactReducer from "./slices/contactSlice";
import newsReducer from "./slices/newsSlice";
import aboutReducer from "./slices/aboutSlice";
import settingsReducer from "./slices/settingsSlice";
import productReducer from "./slices/productSlice";
import sliderGroupReducer from "./slices/sliderGroupSlice";
import productDetailReducer from "./slices/productDetailSlice";
import documentReducer from "./slices/documentSlice";
import seoReducer from "./slices/seoSlice";

export const store = configureStore({
  reducer: {
    lang: langReducer,
    showMenu: showMenuReducer,
    login: loginReducer,
    content: contentReducer,
    menuGroup: menuGroupReducer,
    contact: contactReducer,
    news: newsReducer,
    about: aboutReducer,
    settings: settingsReducer,
    sliderGroup: sliderGroupReducer,
    product: productReducer,
    productDetail: productDetailReducer,
    document: documentReducer,
    seo: seoReducer,
  },
});

export default store;
